import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import moment from '../../../lib/moment.js'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Button,
} from 'reactstrap'
import styled from 'styled-components'

export const ShowRemark = (props) => {
  const { open, toggle, snapshot } = props
  return (
  /* eslint no-underscore-dangle: 0 */
    <Modal
      isOpen={ open }
      toggle={ () => toggle() }
    >
      <HeaderForm toggle={ () => toggle() }>
        <HeadLabel>{ `Remark Version ${get(snapshot, 'version', '')}` }</HeadLabel>
      </HeaderForm>
      <ModalBody>
        <TextLabel>Saved by</TextLabel>
        <br />
        <Label>{ get(snapshot, 'saved_by', '') } { get(snapshot, 'updated') ? moment(get(snapshot, 'updated')).format('DD/MM/YYYY HH:mm') : '' }</Label>
        <br />
        <Label>{ get(snapshot, 'remark', '-') }</Label>
      </ModalBody>
      <ModalFooter>
        <Button onClick={ () => toggle() }>Cancel</Button>
      </ModalFooter>
    </Modal>
  )
}

ShowRemark.propTypes = {
  toggle: PropTypes.func,
  open: PropTypes.bool,
  snapshot: PropTypes.any,
}
ShowRemark.defaultProps = {
  toggle: () => {},
  open: false,
  snapshot: {},
}

const HeaderForm = styled(ModalHeader)`
  font-family: Gotham-Bold;
  font-size: 12px ;
`
const HeadLabel = styled(Label)`
  font-family: Gotham-Bold;
  font-size: 16px ;
  color: #AD2624;
  margin-left: 5px;
`
const TextLabel = styled(Label)`
  font-family: Gotham-Bold;
  font-size: 16px ;
`



// WEBPACK FOOTER //
// ./src/components/project-information/form/show-remark-snapshot.js